export const compressImage = async (file, maxSizeKB = 500) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = async (event) => {
        const img = new Image();
        
        img.onload = async () => {
          // Start with reasonable dimensions and quality
          let maxWidth = 1920;
          let maxHeight = 1080;
          let quality = 0.8;
          let attempts = 0;
          const maxAttempts = 10;
  
          const compress = async () => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;
  
            // Calculate new dimensions while maintaining aspect ratio
            if (width > height) {
              if (width > maxWidth) {
                height = (height * maxWidth) / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width = (width * maxHeight) / height;
                height = maxHeight;
              }
            }
  
            canvas.width = width;
            canvas.height = height;
  
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
  
            return new Promise((resolveBlob) => {
              canvas.toBlob(
                (blob) => {
                  resolveBlob(blob);
                },
                'image/jpeg',
                quality
              );
            });
          };
  
          let blob = await compress();
          attempts++;
  
          // Keep compressing until under 500KB or max attempts reached
          while (blob && blob.size > maxSizeKB * 1024 && attempts < maxAttempts) {
            // Reduce quality more aggressively if file is still too large
            if (quality > 0.5) {
              quality -= 0.1;
            } else {
              // If quality is already low, reduce dimensions
              maxWidth = Math.floor(maxWidth * 0.8);
              maxHeight = Math.floor(maxHeight * 0.8);
            }
            
            blob = await compress();
            attempts++;
            console.log(`Compression attempt ${attempts}: ${(blob.size / 1024).toFixed(2)}KB, quality: ${quality.toFixed(2)}, dimensions: ${maxWidth}x${maxHeight}`);
          }
  
          if (blob) {
            console.log('Original size:', (file.size / 1024).toFixed(2), 'KB');
            console.log('Final compressed size:', (blob.size / 1024).toFixed(2), 'KB');
            
            const compressedFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(compressedFile);
          } else {
            reject(new Error('Canvas to Blob conversion failed'));
          }
        };
  
        img.onerror = () => reject(new Error('Image load failed'));
        img.src = event.target.result;
      };
  
      reader.onerror = () => reject(new Error('FileReader failed'));
      reader.readAsDataURL(file);
    });
  };